
export function FooterAttribution() {
  return (
    <div className="text-center text-gray-500 text-sm mt-6 mb-4">
      <p className="mb-0.5">Created by:</p>
      <a 
        href="https://matchmylogic.com" 
        target="_blank" 
        rel="noopener noreferrer"
        className="text-gray-600 hover:text-gray-800 underline"
      >
        matchmylogic.com
      </a>
      
      {/* Add contributor link below the matchmylogic link */}
      <div className="mt-2">
        <a 
          href="https://docs.google.com/forms/d/e/1FAIpQLSfH-BgMlXeSA-yxir-Ai-fMBL2FlAZM_82PIHQC9QOxypRjsA/viewform?usp=header" 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-gray-600 hover:text-gray-800 underline text-xs"
        >
          Be a contributor
        </a>
      </div>
    </div>
  );
}
